import angular from 'angular'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.consumer', dependencies).name;